// extracted by mini-css-extract-plugin
export var headerCell = "_4w-1";
export var loadingSpinnerContainer = "_4w-4";
export var loadingStateCell = "_4w-5";
export var rowWrapper = "_4w-3";
export var standaloneTable = "_4w-6";
export var table = "_4w-0";
export var white = "_4w-2";